export default "__VITE_ASSET__JaVf7Nq8__"